import type { ArColumnDefinition } from '#types/System.Artifacts.types';
import type { UIArTableColumnOverride } from '#types/System.types';

const applyColumnConfig = (
    columns: ArColumnDefinition[],
    columnConfig: UIArTableColumnOverride[],
): ArColumnDefinition[] => {
    const columnMap = new Map(columns.map(col => [col.typeId, col]));

    return columnConfig.reduce<ArColumnDefinition[]>((result, override) => {
        const column = columnMap.get(override.typeId);
        if (!column) return result;

        if (override.labelOverride) {
            result.push({
                ...column,
                descriptionOverride: {
                    ...column.descriptionOverride,
                    shortLabel: override.labelOverride,
                },
            });
        } else {
            result.push(column);
        }
        return result;
    }, []);
};

export { applyColumnConfig };
